import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { TermsComponent } from './pages/terms/terms.component';
import { CartComponent } from './pages/cart/cart.component';
import { HelpCenterComponent } from './pages/help-center/help-center.component';
import { ProductDetailsComponent } from './pages/product-details/product-details.component';
import { SearchComponent } from './pages/search/search.component';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { MyProfileComponent } from './pages/my-profile/my-profile.component';
import {MantenimientoComponent} from './pages/mantenimiento/mantenimiento.component';
import { AsociateComponent } from './pages/asociate/asociate.component';
import { PaymentRedirectComponent } from './pages/payment-redirect/payment-redirect.component';


const routes: Routes = [
  {
    path: '',
    component: HomeComponent
    //component: MantenimientoComponent
  },
  {
    path: 'inicio',
    component: HomeComponent
    //component: MantenimientoComponent
  },
  {
    path: 'acceso',
    component: HomeComponent
    //component: MantenimientoComponent
  },
  {
    path: 'entrada',
    component: HomeComponent
    //component: MantenimientoComponent
  },
  {
    path: 'carrito-de-compras',
    component: CartComponent
    //component: MantenimientoComponent
  },
  {
    path: 'producto/:id',
    component: ProductDetailsComponent
  },
  {
    path: 'producto/:id/:slug',
    component: ProductDetailsComponent
  },
  {
    path: 'buscar/categoria/:category_id/:category_name',
    component: SearchComponent
  },
  {
    path: 'buscar-producto',
    component: SearchComponent
  },
  {
    path: 'terminos-y-condiciones',
    component: TermsComponent
  },
  {
    path: 'centro-de-ayuda',
    component: HelpCenterComponent
  },
  {
    path: 'asociate',
    component: AsociateComponent
  },
  {
    path: 'pedido/resultado',
    component: PaymentRedirectComponent
  },
  {
    path: 'checkout',
    component: CheckoutComponent
    //component: MantenimientoComponent
  },
  {
    path: 'pago-confirmado/:id',
    component: CheckoutComponent,
    //component: MantenimientoComponent,
    data: {
      step: 3
    }
  },
  {
    path: 'pago-cancelado',
    component: CheckoutComponent,
    //component: MantenimientoComponent,
    data: {
      step: 4
    }
  },
  {
    path: 'pagina-no-encontrada',
    component: PageNotFoundComponent
    //component: MantenimientoComponent
  },
  {
    path: 'mi-cuenta',
    component: MyProfileComponent,
  },
  {
    path: '**', redirectTo: '/pagina-no-encontrada'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
